import photo_restoration from './images/other_services/photo_restoration.jpg';
import studio_photography from './images/other_services/studio_photography.jpg';
import poster_print from './images/other_services/poster_print.jpg';
import movie_transfers from './images/other_services/movie_transfers.jpg';
import video_montages from './images/other_services/video_montages.jpg';

import './css/OtherServices.css';

function OtherServices() {
    return (
        <div className="other-services">
          <div className="service-row">
            <div className="img-container">
              <img src={photo_restoration} alt="Gill Associates Photography - A Full Service studio" />
            </div>
            <div className="service-text">
              <div className="service-header">PHOTO RESTORATION</div>
              <div className="service-description">Preserve the precious memories of a lifetime that old photos bring with our expert restoration services. We’ve had thirty plus years of experience in the field, serving museums, libraries, and historical societies, duplicating and restoring their valuable images. We continue to practice the craft of b/w film processing and hand printing negatives in our fully functional darkroom facility, and integrate those skills with state-of-the-art digital scanning, retouching and printing – all performed on-site for your full confidence and safety.</div>
            </div>
            <hr/>
          </div>

          <div className="service-row">
            <div className="img-container">
              <img src={studio_photography} alt="Gill Associates Photography - A Full Service studio" />
            </div>
            <div className="service-text">
              <div className="service-header">STUDIO PHOTOGRAPHY</div>
              <div className="service-description">Studio photography is an art that we have spent years perfecting. Our spacious, modern studio space is ideally suited for headshots, family photos, product photography and other projects such as portfolio art copying that requires the unique, controlled environment of a photo studio.</div>
            </div>
            <hr/>
          </div>

          <div className="service-row">
            <div className="img-container">
              <img src={poster_print} alt="Gill Associates Photography - A Full Service studio" />
            </div>
            <div className="service-text">
              <div className="service-header">POSTER PRINT</div>
              <div className="service-description">Perfect for sign-in boards, photo enlargements, displays and signage – we create photo quality, full color reproductions on paper, mounted board, fabric, self-stick stock, canvas, and even outdoor material, from 44” wide to 100’ long. Provide you own designs, or work with our talented artists to create the perfect poster.</div>
            </div>
            <hr/>
          </div>

          <div className="service-row">
            <div className="img-container">
              <img src={movie_transfers} alt="Gill Associates Photography - A Full Service studio" />
            </div>
            <div className="service-text">
              <div className="service-header">MOVIE TRANSFERS</div>
              <div className="service-description">What’s your format – VHS, hi-8 tape, mini DV, audio cassette tape, 8MM and 16MM movie film, reel to reel audio, even European PAL – we do it all, in-house for your privacy and protection. In addition to straight digital transfers to disc, we can edit, add titles and graphics, music and narration – all the elements needed to create and preserve your movie masterpieces.</div>
              </div>
            <hr/>
          </div>

          <div className="service-row">
            <div className="img-container">
              <img src={video_montages} alt="Gill Associates Photography - A Full Service studio" />
            </div>
            <div className="service-text">
              <div className="service-header">VIDEO MONTAGES</div>
              <div className="service-description">Unlike the boring template power point shows you’ve seen, we scan every slide and print to color and tone perfection, and then create a unique mix of special effects, transitions and still animations, coupled with just the right music, for an exciting one of a kind audio/visual presentation. These are becoming “must have” additions to weddings and engagements, anniversaries and birthday celebrations.</div>
            </div>
          </div>
        </div>
    );
}

export default OtherServices;
